// Module
var code = `<div class="statistics"> <component-heading></component-heading> <div id="circle-chart"></div> <div id="stats-items"></div> </div> `;
// Exports
export default code;